import { HELP_CENTER_URL } from '@aloft/toolkit-shared';
import { Flex, Link, Typography } from '@aloft/toolkit-sui';

import { MapAlert } from './MapAlert.tsx';

type MapAlertsProps = {
  hasDrawnPolygon: boolean;
  hasResults: boolean;
  isLoading: boolean;
};

export const MapAlerts = ({ hasDrawnPolygon, hasResults, isLoading }: MapAlertsProps) => {
  if (!hasDrawnPolygon) {
    return <MapAlert>Define a geographic boundary to find pairs</MapAlert>;
  }

  if (hasDrawnPolygon && !hasResults && !isLoading) {
    return (
      <MapAlert>
        <Flex>
          <Typography color="textOffset">
            No pairs found. To find pairs please expand your filters or explore our&nbsp;
            <Link href={HELP_CENTER_URL} isExternal color="textOffset">
              MLS coverage here
            </Link>
            .
          </Typography>
        </Flex>
      </MapAlert>
    );
  }
  return null;
};
